import { ReactNode, useState } from "react";
import { ThemeAvatar } from "../image-field/components/theme-avatar/theme-avatar";
import { ThemeDefault } from "../image-field/components/theme-default/theme-default";

import "cropperjs/dist/cropper.css";
import { CropperModal } from "./cropper-modal";
import { FieldWrapper } from "@/forms/field-wrapper";
import { useFormContext } from "react-hook-form";

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

export const CroppedImageField = ({
  field,
  onChange = () => {},
  theme = "default",
  aspectRatio,
  labelClassName = undefined,
  verificationText,
}: FormField & {
  theme?: string;
  aspectRatio?: number;
  verificationText?: ReactNode;
}) => {
  const [cropper, setCropper] = useState(null);
  const [image, setImage] = useState(null);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const { control } = useFormContext();

  return (
    <FieldWrapper
      field={field}
      control={control}
      labelClassName={labelClassName}
      renderComponent={(formField) => {
        const onInput = (event) => {
          getBase64(event.target.files[0]).then((base64Content) => {
            setImage(base64Content);
          });
          setIsOpenModal(true);
        };

        const onSave = () => {
          if (cropper) {
            const croppedImage = cropper.getCroppedCanvas().toDataURL();
            formField.onChange(croppedImage);
            onChange(croppedImage);
            setIsImageLoaded(true);
          }
        };

        const removeImage = () => {
          formField.onChange(null);
          onChange(null);
          setImage(null);
          setCropper(null);
        };

        const imageOnClick = () => {
          if (isImageLoaded) setIsOpenModal(true);
        };

        const componentProps = {
          field,
          formField,
          onInput,
          removeImage,
          imageOnClick,
          setIsOpenModal,
        };

        return (
          <>
            {theme === "avatar" ? (
              <ThemeAvatar {...componentProps} />
            ) : (
              <ThemeDefault {...componentProps} />
            )}

            {verificationText}

            <CropperModal
              image={image}
              aspectRatio={aspectRatio}
              cropper={cropper}
              setCropper={setCropper}
              onSave={onSave}
              isOpenModal={isOpenModal}
              setIsOpenModal={setIsOpenModal}
            />
          </>
        );
      }}
    />
  );
};
